import { useState, useEffect } from "react";
import { Menu, X, Phone, ChevronRight, ExternalLink, User, Store } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import { useLocation } from "react-router-dom";
// import { Link } from "react-router-dom"; // Disabled — vitrine mode (no internal e-commerce links)
// import { ShoppingCart, LogIn } from "lucide-react"; // Disabled — vitrine mode
// import { useCartStore } from "@/stores/cart"; // Disabled — vitrine mode
// import { supabase } from "@/lib/supabase"; // Disabled — vitrine mode
import ciedaLogo from "@/assets/cieda-logo-dark.webp";
import { NAV_LINKS, CIEDA_PHONE, CIEDA_PHONE_TEL } from "@/lib/constants";
// import { FeatureFlagsPanel } from "@/components/settings/FeatureFlagsPanel"; // Disabled — vitrine mode

const DJAYMA_URL = "https://djayma.com";

const Header = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const isHomePage = location.pathname === "/";

  // DISABLED — auth state tracking (vitrine mode)
  // const [isLoggedIn, setIsLoggedIn] = useState(false);
  // useEffect(() => {
  //   supabase.auth.getSession().then(({ data }) => {
  //     setIsLoggedIn(!!data.session);
  //   });
  //   const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
  //     setIsLoggedIn(!!session);
  //   });
  //   return () => subscription.unsubscribe();
  // }, []);

  // DISABLED — cart state (vitrine mode)
  // const cartItems = useCartStore((s) => s.items);
  // const cartCount = cartItems.reduce((sum, i) => sum + i.quantity, 0);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // Lock body scroll when mobile menu is open
  useEffect(() => {
    document.body.style.overflow = mobileOpen ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [mobileOpen]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled || !isHomePage
          ? "bg-primary/95 backdrop-blur-xl shadow-lg shadow-primary/10"
          : "bg-transparent"
      }`}
    >
      <div className="container-max flex items-center justify-between h-24 md:h-28 px-5 sm:px-8 lg:px-10">
        {/* Logo — prominent brand mark */}
        <a href="/" className="flex items-center group shrink-0">
          <img
            src={ciedaLogo}
            alt="CIEDA — Compagnie Import Export & Distribution Africaine"
            className="h-20 md:h-24 w-auto transition-transform duration-300 group-hover:scale-[1.03]"
          />
        </a>

        {/* Desktop navigation — centered */}
        <nav className="hidden lg:flex items-center gap-0.5 mx-auto">
          {NAV_LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="relative px-3.5 py-2 text-primary-foreground/85 hover:text-primary-foreground transition-colors duration-200 text-[13px] font-medium tracking-wide whitespace-nowrap group"
            >
              {link.label}
              <span className="absolute bottom-0.5 left-3.5 right-3.5 h-[2px] bg-secondary rounded-full scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left" />
            </a>
          ))}
        </nav>

        {/* Desktop right actions — clean hierarchy */}
        <div className="hidden lg:flex items-center gap-1.5 shrink-0">
          {/* Phone — icon with number, subtle */}
          <a
            href={CIEDA_PHONE_TEL}
            className="flex items-center gap-1.5 px-3 py-2 text-primary-foreground/60 hover:text-primary-foreground transition-colors duration-200 text-xs font-medium rounded-lg hover:bg-primary-foreground/5"
            aria-label={`Appeler ${CIEDA_PHONE}`}
          >
            <Phone size={14} strokeWidth={1.5} />
            <span className="hidden xl:inline">{CIEDA_PHONE}</span>
          </a>

          {/* Separator */}
          <div className="w-px h-5 bg-primary-foreground/15 mx-1" />

          {/* Boutique link */}
          <a
            href={DJAYMA_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-1.5 px-3 py-2 text-primary-foreground/70 hover:text-primary-foreground hover:bg-primary-foreground/5 transition-all duration-200 text-xs font-medium rounded-lg"
            aria-label="Boutique Djayma"
          >
            <Store size={14} strokeWidth={1.5} />
            Boutique
          </a>

          {/* Mon compte */}
          <a
            href={`${DJAYMA_URL}/account/login`}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-1.5 px-3 py-2 text-primary-foreground/70 hover:text-primary-foreground hover:bg-primary-foreground/5 transition-all duration-200 text-xs font-medium rounded-lg"
            aria-label="Mon compte"
          >
            <User size={14} strokeWidth={1.5} />
            Compte
          </a>

          {/* DISABLED — feature flags panel (vitrine mode)
          <FeatureFlagsPanel />
          */}

          {/* CTA — Commander */}
          <a
            href={DJAYMA_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1.5 ml-1.5 px-4 py-2 rounded-lg bg-secondary text-secondary-foreground text-xs font-semibold hover:bg-gold-light transition-all duration-300 shine"
          >
            Commander
            <ChevronRight size={13} strokeWidth={2} />
          </a>

          {/* DISABLED — original cart, account, and commander links (vitrine mode)
          <Link
            to="/panier"
            className="relative flex items-center justify-center w-10 h-10 rounded-full text-primary-foreground/70 hover:text-primary-foreground hover:bg-primary-foreground/10 transition-all"
            aria-label="Panier"
          >
            <ShoppingCart size={18} />
            {cartCount > 0 && (
              <span aria-live="polite" className="absolute -top-0.5 -right-0.5 w-5 h-5 rounded-full bg-secondary text-secondary-foreground text-xs font-bold flex items-center justify-center">
                {cartCount > 99 ? "99+" : cartCount}
              </span>
            )}
          </Link>
          <Link
            to="/compte"
            className="flex items-center justify-center w-10 h-10 rounded-full text-primary-foreground/70 hover:text-primary-foreground hover:bg-primary-foreground/10 transition-all"
            aria-label="Mon compte"
          >
            <User size={18} />
          </Link>
          <Link to={isHomePage ? "/#catalog" : "/#catalog"} onClick={() => { if (isHomePage) { const el = document.getElementById("catalog"); el?.scrollIntoView({ behavior: "smooth" }); } }} className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-secondary text-secondary-foreground text-sm font-semibold hover:bg-gold-light transition-all duration-300 shine">
            Commander
            <ChevronRight size={14} />
          </Link>
          */}
        </div>

        {/* Mobile right side */}
        <div className="flex lg:hidden items-center gap-1">
          {/* Phone — icon only */}
          <a
            href={CIEDA_PHONE_TEL}
            className="flex items-center justify-center w-10 h-10 rounded-lg text-primary-foreground/70 hover:text-primary-foreground hover:bg-primary-foreground/5 transition-colors"
            aria-label={`Appeler ${CIEDA_PHONE}`}
          >
            <Phone size={18} strokeWidth={1.5} />
          </a>

          {/* Boutique link — icon only on mobile */}
          <a
            href={DJAYMA_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center w-10 h-10 rounded-lg text-primary-foreground/70 hover:text-primary-foreground hover:bg-primary-foreground/5 transition-colors"
            aria-label="Boutique Djayma"
          >
            <Store size={18} strokeWidth={1.5} />
          </a>

          {/* DISABLED — original mobile cart link (vitrine mode)
          <Link
            to="/panier"
            className="relative flex items-center justify-center w-10 h-10 rounded-full text-primary-foreground/70 hover:text-primary-foreground"
            aria-label="Panier"
          >
            <ShoppingCart size={20} />
            {cartCount > 0 && (
              <span className="absolute -top-0.5 -right-0.5 w-5 h-5 rounded-full bg-secondary text-secondary-foreground text-xs font-bold flex items-center justify-center">
                {cartCount > 99 ? "99+" : cartCount}
              </span>
            )}
          </Link>
          */}

          <button
            className="flex items-center justify-center w-10 h-10 rounded-lg text-primary-foreground hover:bg-primary-foreground/5 transition-colors"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Menu"
          >
            {mobileOpen ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {/* Mobile slide-in drawer */}
      <AnimatePresence>
        {mobileOpen && (
          <>
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.3 }}
              className="lg:hidden fixed inset-0 bg-primary/60 backdrop-blur-sm z-40"
              onClick={() => setMobileOpen(false)}
            />
            <motion.nav
              initial={{ x: "100%" }}
              animate={{ x: 0 }}
              exit={{ x: "100%" }}
              transition={{ type: "spring", damping: 30, stiffness: 300 }}
              className="lg:hidden fixed top-0 right-0 bottom-0 w-[min(300px,85vw)] bg-primary z-50 shadow-2xl flex flex-col"
            >
              <div className="flex items-center justify-between p-5 border-b border-primary-foreground/10">
                <img src={ciedaLogo} alt="CIEDA" className="h-14 w-auto" />
                <button
                  onClick={() => setMobileOpen(false)}
                  className="flex items-center justify-center w-9 h-9 rounded-lg text-primary-foreground hover:bg-primary-foreground/5 transition-colors"
                  aria-label="Fermer le menu"
                >
                  <X size={20} />
                </button>
              </div>

              <div className="flex-1 overflow-y-auto px-4 py-5 space-y-0.5">
                {NAV_LINKS.map((link, i) => (
                  <motion.a
                    key={link.href}
                    href={link.href}
                    onClick={() => setMobileOpen(false)}
                    initial={{ opacity: 0, x: 20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ delay: i * 0.05 }}
                    className="block px-4 py-3 text-primary-foreground/85 hover:text-secondary hover:bg-primary-foreground/5 rounded-lg transition-all text-sm font-medium"
                  >
                    {link.label}
                  </motion.a>
                ))}

                {/* Separator */}
                <div className="h-px bg-primary-foreground/10 my-3 mx-4" />

                {/* Mobile Djayma links */}
                <a
                  href={DJAYMA_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => setMobileOpen(false)}
                  className="flex items-center gap-3 px-4 py-3 text-primary-foreground/85 hover:text-secondary hover:bg-primary-foreground/5 rounded-lg transition-all text-sm font-medium"
                >
                  <Store size={16} strokeWidth={1.5} />
                  Boutique
                  <ExternalLink size={12} className="ml-auto text-primary-foreground/40" />
                </a>

                <a
                  href={`${DJAYMA_URL}/account/login`}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => setMobileOpen(false)}
                  className="flex items-center gap-3 px-4 py-3 text-primary-foreground/85 hover:text-secondary hover:bg-primary-foreground/5 rounded-lg transition-all text-sm font-medium"
                >
                  <User size={16} strokeWidth={1.5} />
                  Mon compte
                  <ExternalLink size={12} className="ml-auto text-primary-foreground/40" />
                </a>

                {/* DISABLED — original mobile account links (vitrine mode)
                {isLoggedIn ? (
                  <Link
                    to="/compte"
                    onClick={() => setMobileOpen(false)}
                    className="flex items-center gap-3 px-4 py-3 text-primary-foreground/80 hover:text-secondary hover:bg-primary-foreground/5 rounded-lg transition-all text-sm font-medium mt-4"
                  >
                    <User size={16} />
                    Mon compte
                  </Link>
                ) : (
                  <>
                    <Link
                      to="/connexion"
                      onClick={() => setMobileOpen(false)}
                      className="flex items-center gap-3 px-4 py-3 text-primary-foreground/80 hover:text-secondary hover:bg-primary-foreground/5 rounded-lg transition-all text-sm font-medium mt-4"
                    >
                      <LogIn size={16} />
                      Se connecter
                    </Link>
                    <Link
                      to="/inscription"
                      onClick={() => setMobileOpen(false)}
                      className="flex items-center gap-3 px-4 py-3 text-primary-foreground/80 hover:text-secondary hover:bg-primary-foreground/5 rounded-lg transition-all text-sm font-medium"
                    >
                      <User size={16} />
                      Creer un compte
                    </Link>
                  </>
                )}
                */}
              </div>

              <div className="p-4 border-t border-primary-foreground/10 space-y-2">
                <a
                  href={DJAYMA_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center justify-center gap-2 px-4 py-3 rounded-lg bg-secondary text-secondary-foreground text-sm font-semibold hover:bg-gold-light transition-colors"
                >
                  Commander sur Djayma
                  <ChevronRight size={14} />
                </a>
                <a
                  href={CIEDA_PHONE_TEL}
                  className="flex items-center justify-center gap-2 py-2 text-primary-foreground/60 text-xs font-medium"
                >
                  <Phone size={13} strokeWidth={1.5} />
                  {CIEDA_PHONE}
                </a>
              </div>
            </motion.nav>
          </>
        )}
      </AnimatePresence>
    </header>
  );
};

export default Header;
